export default __webpack_public_path__ + "static/media/bank-line.13337888.svg";